<template>
  <div class="report">
    <div class="page-header-wrapper">
      <PageHeader title="Content Hits View"></PageHeader>
      <el-form class="filter-wrapper" :model="form" label-width="60px">
        <el-col :span="6" v-role="[1]">
          <el-form-item
            label="Role"
            prop="role"
          >
            <el-select
              v-model="form.role"
              placeholder="Please select Role"
              filterable
              @change="roleChange"
            >
              <el-option
                v-for="(item, idx) in roleOptions"
                :key="idx"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-role="[1]">
          <el-form-item
            label="Leader"
            prop="taId"
          >
            <el-select
              v-model="form.taId"
              placeholder="Please select Leader"
              filterable
              @change="taChange"
            >
              <el-option
                v-for="(item, idx) in taOptions"
                :key="idx"
                :label="item.TAName"
                :value="item.TAID"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Team" prop="teamId">
            <el-select
              v-model="form.teamId"
              placeholder="Please select Team"
              filterable
            >
              <el-option
                v-for="(item, idx) in teamOptions"
                :key="idx"
                :label="item.TeamName"
                :value="item.TeamID"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Year" prop="year">
            <el-select v-model="form.year" placeholder="Please select year">
              <el-option
                v-for="item in yearsOptions"
                :key="item.Year"
                :label="item.Year"
                :value="item.Year"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Month" prop="month">
            <el-select
              class="month-select"
              ref="monthSelect"
              v-model="form.month"
              placeholder="Please select month"
              multiple
              v-multiple-tip
              @change="monthSelectChange"
            >
              <el-option
                v-for="item in monthOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Type" prop="type">
            <el-select
              v-model="form.type"
              placeholder="Please select type"
            >
              <el-option label="All" value=""/>
              <el-option label="Content Push" value="ContentMeetingPush"/>
              <el-option label="Quick Push" value="QuickPush"/>
            </el-select>
          </el-form-item>
        </el-col>
        <div class="query-action">
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getTableData()"
            :disabled="queryable"
          >
            Query
          </el-button>
          <el-button
            type="primary"
            icon="iconfont icon-export"
            @click="getTableData(true)"
            :disabled="exportable"
            :loading="exporting"
          >
            Export
          </el-button>
        </div>
      </el-form>
    </div>
    <div class="charts" ref="charts" v-role="[1, 2, 4, 6, 8, 10, 12]">
      <div class="chart-row">
        <div class="chart-wrapper">
          <h4>Rate Of Hits</h4>
          <div v-show="!hitsRateDataEmpty" class="chart" ref="hitsRate"></div>
          <div v-show="hitsRateDataEmpty" class="chart empty">
            <span>No Data</span>
          </div>
        </div>
        <div class="chart-wrapper">
          <h4>No. Of Hits</h4>
          <div v-show="!hitsCountDataEmpty" class="chart" ref="hitsCount"></div>
          <div v-show="hitsCountDataEmpty" class="chart empty">
            <span>No Data</span>
          </div>
        </div>
      </div>
    </div>
    <div class="table-wrapper">
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        element-loading-text="Loading..."
      >
        <el-table-column prop="MLName" label="User" min-width="100" />
        <el-table-column prop="TaConfigName" label="TA" min-width="130" />
        <el-table-column prop="SVName" label="Manager" min-width="100" />
        <el-table-column prop="TeamName" label="Team" min-width="90" />
        <el-table-column prop="PushCount" label="No. Of Push" min-width="110" />
        <el-table-column
          min-width="200"
          prop="ContentCount"
          label="No. Of Pushed Content"
        />
        <el-table-column prop="HitsCount" label="No. Of Hits" min-width="100" />
        <el-table-column prop="HitsRate" label="Rate Of Hits" min-width="110" />
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  addResizeListener,
  removeResizeListener,
} from "element-ui/src/utils/resize-event";
import * as echarts from "echarts/core";
import { BarChart, ScatterChart } from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomSliderComponent,
} from "echarts/components";
import { SVGRenderer } from "echarts/renderers";
echarts.use([
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomSliderComponent,
  BarChart,
  ScatterChart,
  SVGRenderer,
]);
import moment from "moment";
import downloadjs from "downloadjs";
import { getDataZoomOptions } from "../../utils/echarts";
import {RoleCode} from "@/utils/role-constant";
export default {
  name: "Content-Hits-View",
  data() {
    return {
      tableData: [],
      tableLoading: false,
      exporting: false,
      form: {
        role: "",
        taId: "",
        teamId: "",
        year: moment().year(),
        month: [moment().month() + 1],
        type: ""
      },
      otherList: null,
      roleList: [],
      taList: [],
      teamList: [],
      monthOptions: [
        {
          label: "All",
          value: "",
        },
      ],
      // charts as follow:
      loadingOption: {
        text: "loading...",
        color: "#d52b1e",
        lineWidth: 2,
      },
      hitsRateChart: null,
      hitsRateData: null,
      hitsRateDataEmpty: false,
      hitsCountChart: null,
      hitsCountData: null,
      hitsCountDataEmpty: false,
      queryable: true,
      exportable: true,
      resizeListener: null,
    };
  },
  created() {
    this.getData();
    this.bus.$on("refresh", ({ name }) => {
      if (this.$options.name === name) {
        this.getData();
      }
    });
    this.bus.$on("onSideMenuCollapse", () => {
      if (this.$options.name === this.$route.meta.title) {
        echarts.throttle(() => {
          this.renderCharts(true);
        }, 200);
      }
    });
    for (let i = 1; i <= 12; i++) {
      this.monthOptions.push({
        label: i,
        value: i,
      });
    }
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    filterSpan(){
      return this.role === 1 ? 6 : 5;
    },
    teamName() {
      let team = this.teamList.find((item) => item.TeamID === this.form.teamId);
      return team ? team.TeamName : "";
    },
    isShowCharts() {
      return this.role === RoleCode.Admin ||
        this.role === RoleCode.Supervisor ||
        this.role === RoleCode.TALead ||
        this.role === RoleCode.CRPLeader ||
        this.role === RoleCode.CVEOLeader ||
        this.role === RoleCode.SciComLeader ||
        this.role === RoleCode.ClinTransLeader;
    },
    yearsOptions() {
      return this.otherList ? this.otherList.year : [];
    },
    roleOptions() {
      return [{value:"",name:"All"}].concat(this.roleList);
    },
    taOptions() {
      return [{ TAName: "All", TAID: "", RoleName: "" }].concat(
          this.taList.filter(({RoleName}) => {
            return this.form.role ? this.form.role === "MSL" ? RoleName === "TALead" : RoleName.indexOf(this.form.role) > -1 : true;
          })
        );
    },
    teamOptions() {
      let options = this.teamList.filter(({TAID, RoleName}) => {
        return this.form.taId ? this.form.taId === TAID
          : ( RoleName.indexOf(this.form.role) > -1 || (this.form.role === "MSL" && (RoleName === "TALead" || RoleName === "Supervisor")))
      });
      return this.role === 1 || this.role === 4 ? [{ TeamName: "All", TeamID: "", RoleName: "" }].concat(options) : options;
    },
    barWidth() {
      return document.body.clientHeight / 35;
    },
  },
  mounted() {
    if (this.isShowCharts) {
      this.renderCharts();
      this.resizeListener = echarts.throttle(() => {
        if (this.$options.name === this.$route.meta.title) {
          this.onResize();
          this.$nextTick(() => {
            this.renderCharts(true);
          });
        }
      }, 100);
      addResizeListener(this.$refs.charts, this.resizeListener);
    }
  },
  beforeDestroy() {
    if (this.isShowCharts && this.resizeListener) {
      removeResizeListener(this.$refs.charts, this.resizeListener);
    }
  },
  activated() {
    this.onResize();
    this.$nextTick(() => {
      this.renderCharts(true);
    });
  },
  methods: {
    getDataZoomOptions,
    roleChange() {
      this.form.taId = "";
      this.form.teamId = "";
    },
    taChange() {
      this.form.teamId = "";
    },
    monthSelectChange(value) {
      const filter = (val) => val === "";
      const index = value.findIndex(filter);
      const isAll = value.some(filter);
      this.form.month = value.filter((val) => {
        return isAll && (index !== 0 || value.length === 1)
          ? val === ""
          : val !== "";
      });
      if (value.length === 0) {
        this.form.month = [""];
      }
    },
    onResize() {
      if (this.$route.meta.title === this.$options.name) {
        this.hitsRateChart && this.hitsRateChart.resize();
        this.hitsCountChart && this.hitsCountChart.resize();
      }
    },
    renderCharts(hideLoading = false) {
      this.renderHitsRateChart();
      this.renderHitsCountChart();
      if (hideLoading) {
        this.hideLoadings();
      }
    },
    hideLoadings() {
      this.hitsRateChart && this.hitsRateChart.hideLoading();
      this.hitsCountChart && this.hitsCountChart.hideLoading();
    },
    showLoadings() {
      this.hitsRateChart && this.hitsRateChart.showLoading(this.loadingOption);
      this.hitsCountChart &&
        this.hitsCountChart.showLoading(this.loadingOption);
    },
    getTableData(exportable = false) {
      this.tableLoading = !exportable;
      this.exporting = exportable;
      if (this.isShowCharts && !exportable) {
        this.hitsRateDataEmpty = false;
        this.hitsCountDataEmpty = false;
        this.$nextTick(() => {
          this.onResize();
        });
        this.showLoadings();
      }
      const month = this.form.month.filter((value) => value !== "");
      let params = {
        ...this.form,
        month: month.toString(),
        exportable: exportable ? 1 : 0,
      };
      if (exportable) {
        Object.assign(params, {
          teamName: this.teamName,
        });
      }
      this.axios
        .get("analytics/hitsRate", {
          params: params,
          responseType: exportable ? "blob" : "json",
        })
        .then(({ code, data, msg }) => {
          if (exportable) {
            downloadjs(data.file, data.fileName, "application/vnd.ms-excel");
            this.exporting = false;
          } else {
            if (200 === code) {
              this.tableLoading = false;
              const { HitsRate, HitsCount, tableData } = data;
              if (this.isShowCharts) {
                this.hitsRateData = HitsRate;
                this.hitsCountData = HitsCount;
                this.renderCharts(true);
              }
              this.tableData = tableData;
            } else {
              this.$message.error(msg);
            }
          }
        })
        .catch(() => {
          this.exporting = false;
        });
    },
    getData() {
      Promise.all([
        this.axios.get(`analytics/otherList`),
        this.axios.get(`analytics/taList`),
        this.axios.get("analytics/teamList"),
        this.axios.get(`analytics/roleList`)
      ]).then((res) => {
        this.getOtherList(res[0]);
        this.getTAList(res[1]);
        this.getTeamList(res[2]);
        this.getRoleList(res[3]);
        this.queryable = false;
        this.exportable = false;
        this.getTableData();
      });
    },
    getRoleList({ code, data, msg }){
      if (200 === code) {
        this.roleList = data;
        if (this.role === RoleCode.Supervisor || this.role === RoleCode.TALead) {
          const { value } = data[0] || { value:"" };
          this.form.role = value;
        } else {
          const roleName = this.$store.state.userInfo.roleName;
          const { value } = this.roleList.find(({value}) => roleName.indexOf(value)>-1) || { value:"" };
          this.form.role = value;
        }
      } else {
        this.$message.error(msg);
      }
    },
    getOtherList({ code, data, msg }) {
      if (200 === code) {
        this.otherList = data;
      } else {
        this.$message.error(msg);
      }
    },
    getTAList({ code, data, msg }) {
      if (200 === code) {
        this.taList = data;
        if (this.role === 4) {
          this.form.taId = data.length > 0 ? data[0].TAID : "";
        }
      } else {
        this.$message.error(msg);
      }
    },
    getTeamList({ code, data, msg }) {
      if (200 === code) {
        this.teamList = data;
        if (this.role == RoleCode.Supervisor
          || this.role == RoleCode.CRPLeader
          || this.role == RoleCode.CVEOLeader
          || this.role == RoleCode.SciComLeader
          || this.role == RoleCode.ClinTransLeader) {
          this.form.teamId = data.length > 0 ? data[0].TeamID : "";
        }
      } else {
        this.$message.error(msg);
      }
    },
    renderHitsRateChart() {
      let chart = this.$refs.hitsRate;
      let width = chart ? chart.offsetWidth : 0;
      let xAxisData = [];
      let valueData = [];
      if (this.hitsRateData) {
        this.hitsRateData.data.forEach((i) => {
          xAxisData.push(i.name);
          valueData.push((i.value * 100).toFixed(2));
        });
        this.hitsRateDataEmpty = this.hitsRateData.data.length === 0;
      }
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          padding: 6,
          confine: true,
          className: "echart-tooltip",
          formatter([params]) {
            return `<h4>${
              params.name
            }</h4><div class="chart-tooltip"><i style="background:${
              params.color
            }"></i><span>Rate Of Hits</span><strong>${new Number(
              params.data
            ).toFixed(2)}%</strong></div>`;
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          top: 30,
          bottom: 30,
          containLabel: true,
        },
        dataZoom:
          xAxisData.length > 10
            ? this.getDataZoomOptions(
                0,
                document.body.clientWidth <= 1024 ? 30 : 40
              )
            : null,
        xAxis: {
          type: "category",
          data: xAxisData,
          axisLabel: {
            interval: 0,
            lineHeight: 16,
            fontSize: 11,
            width: width / 7,
            overflow: "truncate",
            formatter: (value, index) => {
              return `${
                index % 2 !== 0 && xAxisData.length >= 5 ? "\n" : ""
              }${value}`;
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
          min: -1,
          max: xAxisData.length,
          boundaryGap: false,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            formatter: function (value) {
              return `${value}%`;
            },
          },
        },
        barWidth: this.barWidth,
        series: [
          {
            name: "No. Of Pushed Content",
            type: "scatter",
            itemStyle: {
              opacity: 0.8,
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowColor: "rgba(0,0,0,0.1)",
            },
            data: valueData,
          },
        ],
      };
      if (!this.hitsRateChart) {
        this.hitsRateChart = echarts.init(this.$refs.hitsRate, null, {
          renderer: "svg",
        });
        this.hitsRateChart.showLoading(this.loadingOption);
      }
      this.hitsRateChart.setOption(option);
    },
    renderHitsCountChart() {
      let chart = this.$refs.hitsCount;
      let width = chart ? chart.offsetWidth : 0;
      let xAxisData = [];
      let valueData = [];
      if (this.hitsCountData) {
        this.hitsCountData.data.forEach((i) => {
          xAxisData.push(i.name);
          valueData.push(i.value);
        });
        this.hitsCountDataEmpty = this.hitsCountData.data.length === 0;
      }
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          padding: 6,
          confine: true,
          className: "echart-tooltip",
          formatter([params]) {
            return `<h4>${params.name}</h4><div class="chart-tooltip"><i style="background:${params.color}"></i><span>No. Of Hits</span><strong>${params.data}</strong></div>`;
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          top: 30,
          bottom: 30,
          containLabel: true,
        },
        dataZoom:
          xAxisData.length > 10
            ? this.getDataZoomOptions(
                0,
                document.body.clientWidth <= 1024 ? 30 : 40
              )
            : null,
        xAxis: {
          type: "category",
          data: xAxisData,
          axisLabel: {
            interval: 0,
            lineHeight: 16,
            fontSize: 11,
            width: width / 7,
            overflow: "truncate",
            formatter: (value, index) => {
              return `${
                index % 2 !== 0 && xAxisData.length >= 5 ? "\n" : ""
              }${value}`;
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
          },
        },
        barWidth: this.barWidth,
        series: [
          {
            data: valueData,
            type: "bar",
            label: {
              show: true,
              position: "top",
            },
            itemStyle: {
              color: "#3ba272",
            },
          },
        ],
      };
      if (!this.hitsCountChart) {
        this.hitsCountChart = echarts.init(this.$refs.hitsCount, null, {
          renderer: "svg",
        });
        this.hitsCountChart.showLoading(this.loadingOption);
      }
      this.hitsCountChart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-wrapper {
  padding-top: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: inherit !important;
  flex-wrap: wrap;
  padding: 0 !important;
  .el-form-item {
    margin-bottom: 10px !important;
    .el-select {
      width: 100%;
    }
  }
  .query-action {
    flex: 1;
    margin-bottom: 10px;
    margin-left: 10px;
    white-space: nowrap;
    text-align: right;
  }
}
.request-content-popover {
  background-color: red;
}
</style>
